import React from 'react';
import { ImQuotesLeft, ImStarFull } from "react-icons/im";
import pic3 from '../../Assets/images/pic3.jpg';

import 'swiper/css';

import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

function AboutTestimonial() {
    return (
        <>
            <div className="aon-testmonials-area sf-curve-pos">
                <div className="container">
                    {/*Title Section Start*/}
                    <div className="section-head">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <span className="aon-sub-title">Testimonial</span>
                                <h2 className="sf-title">What People Say</h2>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                    usmod tempor incididunt ut labore et dolore magna aliqua.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/*Title Section End*/}

                    <Swiper
                        className='pb-5'
                        // install Swiper modules
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        // spaceBetween={50}
                        // slidesPerView={3}
                        // navigation
                        breakpoints={{
                            320: {
                                spaceBetween: 5,

                                slidesPerView: 1,
                            },

                            // when window width is >= 576px
                            576: {
                                spaceBetween: 5,

                                slidesPerView: 1,
                            },
                            // when window width is >= 768px
                            768: {
                                spaceBetween: 5,

                                slidesPerView: 1,
                            },
                            // when window width is >= 1024px
                            1024: {
                                spaceBetween: 5,

                                spaceBetween: 10,
                                slidesPerView: 1,
                            },
                            1280: {
                                spaceBetween: 5,

                                slidesPerView: 1,
                            },
                        }}
                        pagination={{ clickable: true }}
                        // scrollbar={{ draggable: true }}
                        onSwiper={(swiper) => console.log(swiper)}
                        onSlideChange={() => console.log('slide change')}
                    >
                        <SwiperSlide>
                            {/* THUMBNAILS */}
                            <div className="slick-testimonials-thumbnails w-30 m-auto">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-user">
                                        <div className="sf-testimonial-media">
                                            <img src={pic3} alt="" />
                                        </div>
                                        <div className="sf-testimonial-user-detail">
                                            <div className="sf-testi-user-name">Mark, Homestay </div>
                                            <div className="sf-testi-user-position">Sales Manager</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* MAIN SLIDES */}
                            <div className="slick-testimonials-carousel">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-info text-center">
                                        <div className="sf-testimonial-title">
                                            It was a great experience
                                        </div>
                                        <div className="sf-ow-pro-rating">
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} />

                                        </div>
                                        <div className="sf-testimonial-text">
                                            <p>
                                                Lorem Ipsum is simply dummy text of the printing and
                                                typesetting industry. Lorem Ipsum has been the industry's
                                                standard dummy text ever since the 1500s, when an unknown
                                                printer took a galley of type and scrambled it to make a type
                                                specimen book. It has survived not only five centuries, but
                                                also the leap into electronic typesettin
                                            </p>
                                        </div>
                                        <div className="sf-testimonial-quote">
                                            <ImQuotesLeft size={30} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* THUMBNAILS */}
                            <div className="slick-testimonials-thumbnails w-30 m-auto">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-user">
                                        <div className="sf-testimonial-media">
                                            <img src={pic3} alt="" />
                                        </div>
                                        <div className="sf-testimonial-user-detail">
                                            <div className="sf-testi-user-name">Mark, Homestay </div>
                                            <div className="sf-testi-user-position">Sales Manager</div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            {/* MAIN SLIDES */}
                            <div className="slick-testimonials-carousel">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-info text-center">
                                        <div className="sf-testimonial-title">
                                            It was a great experience
                                        </div>
                                        <div className="sf-ow-pro-rating">
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} />

                                        </div>
                                        <div className="sf-testimonial-text">
                                            <p>
                                                Lorem Ipsum is simply dummy text of the printing and
                                                typesetting industry. Lorem Ipsum has been the industry's
                                                standard dummy text ever since the 1500s, when an unknown
                                                printer took a galley of type and scrambled it to make a type
                                                specimen book. It has survived not only five centuries, but
                                                also the leap into electronic typesettin
                                            </p>
                                        </div>
                                        <div className="sf-testimonial-quote">
                                            <ImQuotesLeft size={30} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* THUMBNAILS */}
                            <div className="slick-testimonials-thumbnails w-30 m-auto">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-user">
                                        <div className="sf-testimonial-media">
                                            <img src={pic3} alt="" />
                                        </div>
                                        <div className="sf-testimonial-user-detail">
                                            <div className="sf-testi-user-name">Mark, Homestay </div>
                                            <div className="sf-testi-user-position">Sales Manager</div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            {/* MAIN SLIDES */}
                            <div className="slick-testimonials-carousel">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-info text-center">
                                        <div className="sf-testimonial-title">
                                            It was a great experience
                                        </div>
                                        <div className="sf-ow-pro-rating">
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} />

                                        </div>
                                        <div className="sf-testimonial-text">
                                            <p>
                                                Lorem Ipsum is simply dummy text of the printing and
                                                typesetting industry. Lorem Ipsum has been the industry's
                                                standard dummy text ever since the 1500s, when an unknown
                                                printer took a galley of type and scrambled it to make a type
                                                specimen book. It has survived not only five centuries, but
                                                also the leap into electronic typesettin
                                            </p>
                                        </div>
                                        <div className="sf-testimonial-quote">
                                            <ImQuotesLeft size={30} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </SwiperSlide>

                        <SwiperSlide>
                            {/* THUMBNAILS */}
                            <div className="slick-testimonials-thumbnails w-30 m-auto">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-user">
                                        <div className="sf-testimonial-media">
                                            <img src={pic3} alt="" />
                                        </div>
                                        <div className="sf-testimonial-user-detail">
                                            <div className="sf-testi-user-name">Mark, Homestay </div>
                                            <div className="sf-testi-user-position">Sales Manager</div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            {/* MAIN SLIDES */}
                            <div className="slick-testimonials-carousel">
                                {/* COLUMNS 1 */}
                                <div className="slick-item">
                                    <div className="sf-testimonial-info text-center">
                                        <div className="sf-testimonial-title">
                                            It was a great experience
                                        </div>
                                        <div className="sf-ow-pro-rating">
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} className='text-warning me-1' />
                                            <ImStarFull size={20} />

                                        </div>
                                        <div className="sf-testimonial-text">
                                            <p>
                                                Lorem Ipsum is simply dummy text of the printing and
                                                typesetting industry. Lorem Ipsum has been the industry's
                                                standard dummy text ever since the 1500s, when an unknown
                                                printer took a galley of type and scrambled it to make a type
                                                specimen book. It has survived not only five centuries, but
                                                also the leap into electronic typesettin
                                            </p>
                                        </div>
                                        <div className="sf-testimonial-quote">
                                            <ImQuotesLeft size={30} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </SwiperSlide>




                    </Swiper>
                </div>
            </div>
        </>
    )
}

export default AboutTestimonial
